import { Component } from 'vue';

import JsonForm from '@evidentid/json-schema/interfaces/JsonForm';
import { JsonSchemaType } from '@evidentid/json-schema/interfaces/JsonSchema';
import { TprmSchema } from '@evidentid/tprm-portal-lib/models/common/TprmSchema.model';
import { TprmSchemaDisplayFormat } from '@evidentid/tprm-portal-lib/models/common/TprmSchemaDisplayFormat.model';

import CriterionAndOrGroupInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionAndOrGroupInput.vue';
import CriterionArrayInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionArrayInput.vue';
import CriterionArraySortableInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionArraySortableInput.vue';
import CriterionBooleanInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionBooleanInput.vue';
import CriterionCheckboxInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionCheckboxInput.vue';
import CriterionCurrencyInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionCurrencyInput.vue';
import CriterionDaysInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionDaysInput.vue';
import CriterionEnumInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionEnumInput.vue';
import CriterionMonthsInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionMonthsInput.vue';
import CriterionMultiEnumInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionMultiEnumInput.vue';
import CriterionNumberInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionNumberInput.vue';
import CriterionObjectInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionObjectInput.vue';
import CriterionRadioSelectInput from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionRadioSelectInput.vue';
import CriterionTextareaInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionTextareaInput.vue';
import CriterionTextInput
    from '@/modules/decisioning-criteria/components/CriterionInputComponents/CriterionTextInput.vue';
import { getJsonSchemaCompFunction } from '@/utils/getJsonSchemaCustomCompFuntion';

const customFormElementsMap: Record<string, Component> = {
    [JsonSchemaType.boolean]: CriterionBooleanInput,
    [JsonSchemaType.string]: CriterionTextInput,
    [JsonSchemaType.number]: CriterionNumberInput,
    [JsonSchemaType.array]: CriterionArrayInput,
    [JsonSchemaType.object]: CriterionObjectInput,
    [TprmSchemaDisplayFormat.checkbox]: CriterionCheckboxInput,
    [TprmSchemaDisplayFormat.currency]: CriterionCurrencyInput,
    [TprmSchemaDisplayFormat.days]: CriterionDaysInput,
    [TprmSchemaDisplayFormat.months]: CriterionMonthsInput,
    [TprmSchemaDisplayFormat.insuredField]: CriterionEnumInput,
    [TprmSchemaDisplayFormat.multiLine]: CriterionTextareaInput,
    [TprmSchemaDisplayFormat.sortableList]: CriterionArraySortableInput,
    [TprmSchemaDisplayFormat.radioButtons]: CriterionRadioSelectInput,
    [TprmSchemaDisplayFormat.andOrGroup]: CriterionAndOrGroupInput,
    enum: CriterionEnumInput,
    multi_enum: CriterionMultiEnumInput,
};

export function getCriterionJsonSchemaComponent(): (form: JsonForm) => Component {
    const baseFn = getJsonSchemaCompFunction(customFormElementsMap);
    return (form: JsonForm) => {
        // displayFormat takes priority over the multi_enum heuristic in getJsonSchemaCompFunction
        const displayFormat = (form.schema as TprmSchema).displayFormat;
        if (displayFormat && customFormElementsMap[displayFormat]) {
            return customFormElementsMap[displayFormat];
        }
        return baseFn(form);
    };
}
